import { Link } from "react-router-dom";
import { Facebook } from "lucide-react";
import { scrollToSection } from "@/lib/scroll";

export const FACEBOOK_URL = "https://www.facebook.com/share/1KAxAG7G3j/";

// Flip to true once Stripe account is approved (live payments)
const INTAKE_LIVE = true;

const Footer = () => (
  <footer className="bg-black border-t border-white/10" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <span className="w-8 h-8 border border-gold/60 rotate-45 flex items-center justify-center">
              <span className="w-2 h-2 bg-gold -rotate-45" />
            </span>
            <span className="font-serif text-xl text-white">
              Elevated <span className="text-gold italic">Apex</span> Co.
            </span>
          </div>
          <p className="mt-6 text-sm text-neutral-500 font-light leading-relaxed max-w-sm">
            We teach the rules of the credit system so our clients can play it — and win — on their own terms.
          </p>
          <div className="mt-8 flex items-center gap-4">
            <a
              href={FACEBOOK_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Elevated Apex Co. on Facebook"
              className="w-11 h-11 border border-white/15 flex items-center justify-center text-neutral-400 hover:border-gold hover:text-gold transition-colors duration-300"
              data-testid="footer-facebook-link"
            >
              <Facebook className="w-4 h-4" strokeWidth={1.5} />
            </a>
            <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-600">
              Follow the ascent
            </span>
          </div>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">Explore</p>
          <div className="mt-5 flex flex-col gap-3">
            {[
              ["Services", "services"],
              ["Philosophy", "manifesto"],
              ["Academy", "academy"],
              ["Stories", "stories"],
              ["Contact", "contact"],
            ].map(([label, id]) => (
              <button
                key={id}
                onClick={() => scrollToSection(id)}
                className="text-left text-sm text-neutral-400 hover:text-gold transition-colors font-light w-fit"
                data-testid={`footer-link-${id}`}
              >
                {label}
              </button>
            ))}
            {INTAKE_LIVE && (
              <Link
                to="/intake"
                className="text-left text-sm text-neutral-400 hover:text-gold transition-colors font-light w-fit"
                data-testid="footer-link-intake"
              >
                Client Intake
              </Link>
            )}
          </div>
        </div>
        <div className="md:col-span-4">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">The Practice</p>
          <ul className="mt-5 space-y-3 text-sm text-neutral-400 font-light">
            <li>Score Education & Coaching</li>
            <li>Credit Analysis & Action Plans</li>
            <li>Business Credit & Funding Guidance</li>
          </ul>
        </div>
      </div>
      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-6">
        <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-600">
          © 2026 Elevated Apex Co. All rights reserved.
        </p>
        <p className="text-[11px] text-neutral-600 font-light leading-relaxed max-w-2xl">
          Elevated Apex Co. provides educational and coaching services only. We do not
          guarantee specific score outcomes, and results vary by individual history,
          consistency, and reporting cycles. Nothing on this site constitutes legal
          or financial advice.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
